import React from 'react';
import { BsTwitter,  BsLinkedin } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://twitter.com/MichaelAkpoteh3">
        <BsTwitter />
      </a>
    </div>
    <div>
      <a href="https://web.facebook.com/people/Michael-David/100085683737845/?mibextid=ZbWKwL">
        <FaFacebookF />
      </a>
    </div>
    <div>
      <a href="https://www.linkedin.com/in/michael-akpoteheri-1aa458172/">
        <BsLinkedin />
      </a>
    </div>
  </div>
);

export default SocialMedia;
